const SET_JOURNAL_DETAILS = (state, payload) => {
  state.journals.push(...payload.origin.journals);
  state.journalsLoadedAll = payload.origin.journals.length === 0;
};

export default SET_JOURNAL_DETAILS;
